import "country-finder";
import { action, makeAutoObservable, observable } from "mobx";
import { ChangeEvent } from "react";
import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import {
  sendLoginApiCall,
  sendLoginEmailOTPApiCall,
  sendLoginPhoneOTPApiCall,
  verifyLoginEmailOTPApiCall,
  verifyLoginPhoneOTPApiCall,
} from "../../api/auth/loginApi";
import {
  sendLoginEmailApiCall,
  sendLoginPhoneApiCall,
} from "../../api/auth/loginSignupApi";
import { sendProfileApiCall } from "../../api/auth/profileApi";
import { verifyOTP } from "../../api/auth/signupApi";
import { LoginModel } from "../../datamodels/auth/loginModel";
import { LoginSignupModel } from "../../datamodels/auth/loginSignupModel";
import { ProfileModel } from "../../datamodels/auth/profileModel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocialLoginModel } from "../../datamodels/auth/socialLoginModel";
import { sendSocialLoginApiCall } from "../../api/auth/googleLogin";
import { sendSocialFbLoginApiCall } from "../../api/auth/fbLogin";
import "../../css/toastify.css";
import axios from "axios";
import { ctaClickedApiCall } from "../../api/services/ctaAnalytics";
import { CountryCode } from "libphonenumber-js/types";

class LoginViewModel {
  public currentToken: string | null | undefined;
  private dom: Document;

  @observable public countryCode: CountryCode = `IN`;
  @observable public countryName = "";

  constructor(document: Document) {
    makeAutoObservable(this);
    this.dom = document;
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent

        return config;
      },
      async function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      async function (response) {
        return response;
      },
      async function (error) {
        return Promise.reject(error);
      }
    );
    if (localStorage.getItem("@JWTToken") !== null) {
      this.currentToken = localStorage.getItem("@JWTToken");
      this.isLoggedIn = true;
      localStorage.setItem("isLoggedIn", "yes");
      this.getProfile(this.currentToken!);
      console.log(
        "I just sent the profile request from the login view model constructor"
      );
    } else {
      localStorage.setItem("isLoggedIn", "no");
    }
    this.isLoading = false;
    console.log("rebuild");
    this.getGeoInfo();
  }

  @action getGeoInfo = () => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let data = response.data;
        this.countryCode = data.country_code;
        this.countryName = data.country_name;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  @observable public goToPage: string = "/";

  @observable public userId: number | undefined;

  @action queryParamLogin = async () => {
    this.startLoading();
    this.profileResponse = await sendProfileApiCall(
      "Bearer",
      localStorage.getItem("@JWTToken")!
    );
    this.stopLoading();
    if (this.profileResponse.responseInfo.httpCode === 200) {
      localStorage.setItem("isLoggedIn", "yes");
      this.changeUserId(this.profileResponse.data.userId);
      this.username = this.profileResponse.data.userName;
      this.userId = this.profileResponse.data.userId;
      this.goToPage = "start";
      this.goToStart = true;
      // console.log(this.profileResponse.data);
    } else {
      localStorage.setItem("isLoggedIn", "no");
    }
  };

  @action async getProfile(JWTToken: string) {
    this.startLoading();
    this.profileResponse = await sendProfileApiCall(
      "Bearer",
      localStorage.getItem("@JWTToken")!
    );
    this.stopLoading();
    if (this.profileResponse.responseInfo.httpCode === 200) {
      localStorage.setItem("isLoggedIn", "yes");
      this.changeUserId(this.profileResponse.data.userId);
      this.username = this.profileResponse.data.userName;
      this.userId = this.profileResponse.data.userId;

      // console.log(this.profileResponse.data);
    } else {
      localStorage.setItem("isLoggedIn", "no");
    }
  }

  @observable public username: string = "test";

  @observable public usernameField: string = "";
  @observable public passwordField: string = "";
  @observable public selectedCountry: string = "";
  @observable public isoAreaCode: string = "";
  @observable public phoneNumber: string = "";
  @observable public phoneLogin: boolean = false;

  @observable public showOTPScreen: boolean = false;
  @observable public isLoading: boolean = false;

  countryFinder = require("country-finder");

  @observable public saveInfo: boolean = false;
  @observable public isLoggedIn: boolean = false;
  @observable public JWTToken: string = "";

  @observable public loginResponse: LoginModel | undefined;
  @observable public profileResponse: ProfileModel | undefined;

  @observable public otpField: string = "";

  @action handlePinChange = (passedOtp: string): void => {
    this.otpField = passedOtp;
  };

  @action handleResendOtp = async () => {
    // if (this.phoneLogin === true) {
    //   if (isValidPhoneNumber(this.phoneNumber) === true) {
    //     let countryCallingCode = "+" + parsePhoneNumber(this.phoneNumber)?.countryCallingCode.toString()
    //     let number = this.phoneNumber.replace(countryCallingCode, "")
    //     let country = parsePhoneNumber(this.phoneNumber)?.country
    //     this.resendOtpResponse = await sendResendForgotPasswordOtpApiCall(
    //       number,
    //       this.usernameField,
    //       true,
    //       country,
    //     );
    //     if (this.resendOtpResponse.responseInfo.httpCode === 200) {
    //       console.log("successful resend")
    //       alert(this.resendOtpResponse.responseInfo.message);
    //       this.startCountdown();
    //     } else {
    //       alert(this.resendOtpResponse.responseInfo.message);
    //     }
    //   }
    // } else {
    //   this.resendOtpResponse = await sendResendForgotPasswordOtpApiCall(
    //     this.phoneNumber,
    //     this.usernameField,
    //     this.phoneLogin,
    //     this.selectedCountry,
    //   );
    //   if (this.resendOtpResponse.responseInfo.httpCode === 200) {
    //     consolisLoadingtimee.log("successful resend")
    //     alert(this.resendOtpResponse.responseInfo.message);
    //     this.startCountdown();
    //   } else {
    //     alert(this.resendOtpResponse.responseInfo.message);
    //   }
    // }
  };

  @action startLoading() {
    this.isLoading = true;
  }

  @action stopLoading() {
    this.isLoading = false;
  }

  @action handleEmailButton = () => {
    this.phoneLogin = false;
  };

  @action handlePhoneButton = () => {
    this.phoneLogin = true;
  };

  @action handleUsernameChange = (event: ChangeEvent): void => {
    const element = event.currentTarget as HTMLInputElement;
    this.usernameField = element.value;
  };

  @action handlePhoneNumberChange = (val?: string): void => {
    this.phoneNumber = val!;
  };

  @action handlePasswordChange = (event: ChangeEvent): void => {
    const element = event.currentTarget as HTMLInputElement;
    this.passwordField = element.value;
  };

  @action handleCountryChange = (newCountry: string): void => {
    this.selectedCountry = newCountry;
    console.log(this.selectedCountry);
    this.isoAreaCode = this.countryFinder.byCountryCode(
      this.selectedCountry
    ).iso3;
    console.log(this.isoAreaCode);
  };

  // -------- GOOGLE,FB - LOGIN -----------

  @observable public profileName: string = "";

  @observable public socialLoginResponse: SocialLoginModel | undefined;

  @action socialLogIn = async (passedTokenId: string): Promise<void> => {
    this.startLoading();
    ctaClickedApiCall(
      {
        clientToken: passedTokenId,
      },
      "googleLogin",
      "LoginPage",
      "Create",
      false
    );
    this.socialLoginResponse = await sendSocialLoginApiCall(passedTokenId);
    if (this.socialLoginResponse.responseInfo.httpCode === 200) {
      this.changeJwtToken(this.socialLoginResponse.data.accessToken);
      this.changeJwtTokenType(this.socialLoginResponse.data.tokenType);
      this.getProfile(localStorage.getItem("@JWTToken")!);
      this.isLoggedIn = true;
      localStorage.setItem("isLoggedIn", "yes");
      this.goToPage = "start";
    } else {
      this.showToastError(this.socialLoginResponse.responseInfo.message);
    }
    this.stopLoading();
  };
  @action socialFbLogIn = async (
    passedTokenId: string,
    isOnCart: boolean
  ): Promise<void> => {
    this.startLoading();
    ctaClickedApiCall(
      {
        clientToken: passedTokenId,
      },
      "facebookLogin",
      "LoginPage",
      "Create",
      false
    );
    this.socialLoginResponse = await sendSocialFbLoginApiCall(passedTokenId);
    if (this.socialLoginResponse.responseInfo.httpCode === 200) {
      this.changeJwtToken(this.socialLoginResponse.data.accessToken);
      this.changeJwtTokenType(this.socialLoginResponse.data.tokenType);
      this.getProfile(localStorage.getItem("@JWTToken")!);
      this.isLoggedIn = true;
      localStorage.setItem("isLoggedIn", "yes");
      this.goToPage = "start";
    } else {
      console.log("failed to log in");
    }
    this.stopLoading();
  };

  @action logIn = async (): Promise<void> => {
    if (this.phoneLogin === true) {
      if (isValidPhoneNumber(this.phoneNumber) === true) {
        let countryCallingCode =
          "+" +
          parsePhoneNumber(this.phoneNumber)?.countryCallingCode.toString();
        let number = this.phoneNumber.replace(countryCallingCode, "");
        let country = parsePhoneNumber(this.phoneNumber)?.country;
        // this.loginResponse = await sendLoginPhoneOTPApiCall(
        //   number,
        //   true,
        //   country
        // );
        ctaClickedApiCall(
          {
            countryCode: country!,
            mobileNo: number,
            actionMedium: true,
          },
          "phoneLogin",
          "LoginPage",
          "Create",
          false
        );
        this.loginSignupResponse = await sendLoginPhoneApiCall(
          country!,
          number,
          true
        );
        if (this.loginSignupResponse.responseInfo.httpCode === 200) {
          this.showOTPScreen = true;
          this.startCountdown();
        } else {
          this.showToastError(this.loginSignupResponse.responseInfo.message);
        }
      } else {
        this.showToastError("Please enter a valid phone number");
      }
    } else {
      if (this.usernameField) {
        this.loginResponse = await sendLoginApiCall(
          this.phoneNumber,
          this.usernameField,
          this.passwordField,
          this.phoneLogin,
          this.selectedCountry
        );
        if (this.loginResponse.responseInfo.httpCode === 200) {
          console.log("Successful log in");
          this.changeJwtToken(this.loginResponse.data.accessToken);
          this.changeJwtTokenType(this.loginResponse.data.tokenType);
          this.getProfile(localStorage.getItem("@JWTToken")!);
          this.isLoggedIn = true;
          this.JWTToken = localStorage.getItem("@JWTToken")!;
        } else {
          this.showToastError(this.loginResponse.responseInfo.message);
        }
      }
    }
  };

  @observable public loginSignupResponse: LoginSignupModel | undefined;

  @action emailLoginWithOTP = async () => {
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.usernameField)
    ) {
      // this.loginResponse = await sendLoginEmailOTPApiCall(this.usernameField);
      ctaClickedApiCall(
        {
          email: this.usernameField,
          actionMedium: false,
        },
        "emailLogin",
        "LoginPage",
        "Create",
        false
      );
      this.loginSignupResponse = await sendLoginEmailApiCall(
        this.usernameField,
        false
      );
      if (this.loginSignupResponse.responseInfo.httpCode === 200) {
        this.showOTPScreen = true;
        this.startCountdown();
      } else {
        this.showToastError(this.loginSignupResponse.responseInfo.message);
      }
    } else {
      this.showToastError("Please enter a valid email");
    }
  };

  //Go to start
  @observable public goToStart: boolean = false;

  @action verifyOTP = async () => {
    this.startLoading();
    if (this.phoneLogin === true) {
      let countryCallingCode =
        "+" + parsePhoneNumber(this.phoneNumber)?.countryCallingCode.toString();
      let number = this.phoneNumber.replace(countryCallingCode, "");
      let country = parsePhoneNumber(this.phoneNumber)?.country;
      // this.loginResponse = await verifyLoginPhoneOTPApiCall(
      //   number,
      //   true,
      //   this.otpField,
      //   country
      // );
      ctaClickedApiCall(
        {
          profileId: this.loginSignupResponse?.data.profileId!,
          otp: this.otpField,
          deviceInfo: {
            notificationId: "test",
            appVersion: "1.9.2.1",
            appOS: "iOS",
          },
        },
        "verifyOTP_phone",
        "verifyPage",
        "Create",
        false
      );
      this.loginResponse = await verifyOTP(
        this.otpField,
        this.loginSignupResponse?.data.profileId!
      );

      if (this.loginResponse.responseInfo.httpCode === 200) {
        this.isLoggedIn = true;
        localStorage.setItem("isLoggedIn", "yes");
        this.goToPage = "start";
        console.log(this.goToPage);
        this.changeJwtToken(this.loginResponse.data.accessToken);
        this.changeJwtTokenType(this.loginResponse.data.tokenType);
        this.getProfile(localStorage.getItem("@JWTToken")!);
        this.showOTPScreen = false;
        this.usernameField = "";
      } else {
        this.showToastError(this.loginResponse.responseInfo.message);
      }
    } else {
      // this.loginResponse = await verifyLoginEmailOTPApiCall(
      //   this.usernameField,
      //   this.otpField
      // );
      ctaClickedApiCall(
        {
          profileId: this.loginSignupResponse?.data.profileId!,
          otp: this.otpField,
          deviceInfo: {
            notificationId: "test",
            appVersion: "1.9.2.1",
            appOS: "iOS",
          },
        },
        "verifyOTP_email",
        "verifyPage",
        "Create",
        false
      );
      this.loginResponse = await verifyOTP(
        this.otpField,
        this.loginSignupResponse?.data.profileId!
      );
      if (this.loginResponse.responseInfo.httpCode === 200) {
        console.log("Successful log in");
        this.goToPage = "start";
        this.changeJwtToken(this.loginResponse.data.accessToken);
        this.changeJwtTokenType(this.loginResponse.data.tokenType);
        this.getProfile(localStorage.getItem("@JWTToken")!);
        localStorage.setItem("isLoggedIn", "yes");
        this.isLoggedIn = true;
        // this.checkAdminAccess();
      } else {
        this.showToastError(this.loginResponse.responseInfo.message);
      }
    }
    this.stopLoading();
  };

  @observable public hasDashboardAccess: boolean = false;

  @action logOut = () => {
    localStorage.removeItem("@JWTToken");
    this.isLoggedIn = false;
    this.profileResponse = undefined;
    this.loginResponse = undefined;
    this.hasDashboardAccess = false;
    window.location.reload();
  };

  @action keepLoggedIn = (e: ChangeEvent) => {
    const element = e.currentTarget as HTMLInputElement;
    console.log(element.checked);
    this.saveInfo = element.checked;
  };

  @action changeJwtToken = (newJwtToken: string) => {
    localStorage.setItem("@JWTToken", newJwtToken);
  };

  @action changeJwtTokenType = (newJwtTokenType: string) => {
    localStorage.setItem("@JWTTokenType", newJwtTokenType);
  };

  @action changeUserId = (newUserId: number) => {
    localStorage.setItem("@UserId", newUserId.toString());
  };

  @action launchAiDashboard = (): void => {
    window.open(
      // `https://vhive.org/ai/?pid=${this.profileResponse?.data.userId}`,
      `http://dashboard.ai.s3-website-us-east-1.amazonaws.com`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  @observable public seconds: number = 300;
  @observable public minutes: number = 5;
  @observable public countdownTime: string = "5:00";
  @observable public resendOtpEnabled: boolean = false;

  @action startCountdown = (): void => {
    this.resendOtpEnabled = false;
    this.seconds = 300;
    this.tick();
  };

  @action tick = (): void => {
    this.seconds--;
    this.calculateTime();
    if (this.seconds > 0) {
      setTimeout(this.tick, 1000);
    } else {
      this.resendOtpEnabled = true;
    }
  };

  @action calculateTime = (): void => {
    this.countdownTime =
      Math.floor(this.seconds / 60) +
      ":" +
      ("0" + Math.floor(this.seconds % 60)).slice(-2);
  };

  // Toasts
  @action showToastError = (message: string) => {
    toast.error(message, {
      className: "font",
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  @action showToastSuccess = (message: string) => {
    toast.success(message, {
      className: "font",
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
}

export default LoginViewModel;
